export const getVisitorCountState = (
  stats:
    | {
        total_opens: number;
        unique_opens: number;
        unidentified_opens?: number | null;
      }
    | null
    | undefined,
): 'complete' | 'incomplete' | 'unavailable' => {
  if (
    stats == null ||
    stats.total_opens === 0 ||
    stats.unidentified_opens === 0
  ) {
    return 'complete';
  }
  // An older actions container may not report completeness during rollout.
  if (stats.unidentified_opens == null || stats.unique_opens === 0) {
    return 'unavailable';
  }
  return 'incomplete';
};
